import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAdminAuth } from '../../contexts/AdminAuthContext';

const ProtectedAdminRoute = ({ children, requiredPermission = null, requiredRole = null }) => {
  const { isAuthenticated, loading, hasPermission, hasRole } = useAdminAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-[#1E3A8A] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600 font-semibold">جاري التحميل...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  // فحص الصلاحية إذا كانت مطلوبة
  if (requiredPermission && !hasPermission(requiredPermission)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center max-w-md mx-auto p-8">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <span className="text-3xl">🚫</span>
          </div>
          <h1 className="text-2xl font-black text-gray-800 mb-2">غير مصرح لك</h1>
          <p className="text-gray-600 mb-4">
            ليس لديك الصلاحيات اللازمة للوصول إلى هذه الصفحة
          </p>
          <button
            onClick={() => window.history.back()}
            className="px-6 py-2 bg-[#1E3A8A] text-white rounded-lg font-bold hover:bg-[#1E40AF]"
          >
            العودة
          </button>
        </div>
      </div>
    );
  }

  // فحص الدور إذا كان مطلوب
  if (requiredRole && !hasRole(requiredRole)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center max-w-md mx-auto p-8">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <span className="text-3xl">🚫</span>
          </div>
          <h1 className="text-2xl font-black text-gray-800 mb-2">غير مصرح لك</h1>
          <p className="text-gray-600 mb-4">
            هذه الصفحة متاحة فقط لأدوار محددة
          </p>
          <button
            onClick={() => window.history.back()}
            className="px-6 py-2 bg-[#1E3A8A] text-white rounded-lg font-bold hover:bg-[#1E40AF]"
          >
            العودة
          </button>
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedAdminRoute;
